// Spread-out spot positions (percent) for the palette colours of the preview.
const SPOTS = [
  [20, 25],
  [75, 35],
  [45, 75],
  [10, 65],
  [85, 15],
  [55, 20],
  [30, 55],
  [70, 70],
  [15, 40],
  [60, 50],
];

/**
 * The static preview of the generative gradient for a product palette: CSS
 * `background-image` and the base colour under it. With no palette, the
 * image is "none".
 */
export function generativePreview(colors: string[] | undefined): {
  backgroundImage: string;
  baseColor: string;
} {
  let backgroundImage = "none";
  if (colors?.length) {
    backgroundImage = colors
      .concat(colors, colors, colors) // repeat to fill more spots
      .slice(0, Math.max(colors.length * 2, 6))
      .map((c, i) => {
        const [x, y] = SPOTS[i % SPOTS.length];
        return `radial-gradient(circle at ${x}% ${y}%, ${c}cc 0%, ${c}88 30%, transparent 65%)`;
      })
      .join(", ");
  }
  return {backgroundImage, baseColor: colors?.[0] || "#333"};
}
